export default "__VITE_ASSET__C3em61aC__"